export const RESET_ALLOCATION_ISFETCHING = 'RESET_ALLOCATION_ISFETCHING';
export const LIST_ALLOCATIONS_REQUEST = 'LIST_ALLOCATIONS_REQUEST';
export const LIST_ALLOCATIONS_SUCCESS = 'LIST_ALLOCATIONS_SUCCESS';
export const ALLOCATION_LIST_REQUESTING = 'ALLOCATION_LIST_REQUESTING';
